import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '@shared/material.module';

export type ErrorType = 'error' | 'warning' | 'info' | 'network';
export type ErrorDisplayMode = 'card' | 'inline' | 'banner';

@Component({
  selector: 'error-display',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './error-display.component.html',
  styleUrl: './error-display.component.scss'
})
export class ErrorDisplayComponent {
  @Input() message: string = 'Une erreur est survenue';
  @Input() title: string = '';
  @Input() type: ErrorType = 'error';
  @Input() mode: ErrorDisplayMode = 'card';
  @Input() showRetry: boolean = true;
  @Input() showDismiss: boolean = false;
  @Input() details?: string;
  @Input() icon?: string;

  @Output() retry = new EventEmitter<void>();
  @Output() dismiss = new EventEmitter<void>();

  showDetails = false;

  get displayIcon(): string {
    if (this.icon) return this.icon;

    switch (this.type) {
      case 'error':
        return 'error_outline';
      case 'warning':
        return 'warning_amber';
      case 'info':
        return 'info_outline';
      case 'network':
        return 'cloud_off';
      default:
        return 'error_outline';
    }
  }

  get displayTitle(): string {
    if (this.title) return this.title;

    switch (this.type) {
      case 'error':
        return 'Erreur';
      case 'warning':
        return 'Attention';
      case 'info':
        return 'Information';
      case 'network':
        return 'Problème de connexion';
      default:
        return 'Erreur';
    }
  }

  onRetry(): void {
    this.retry.emit();
  }

  onDismiss(): void {
    this.dismiss.emit();
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }
}
